import { useState } from "react";
import { getIcon } from "@/data/tokenIcons";

/**
 * Renders the real token icon. Falls back to a colored letter "bubble" if the image fails.
 * size: "sm" | "md" | "lg"
 */
export default function TokenIcon({ symbol, color = "#222", size = "md", className = "" }) {
  const [errored, setErrored] = useState(false);
  const url = getIcon(symbol);

  const sz = size === "sm" ? "sm" : size === "lg" ? "lg" : "";
  const dim = size === "sm" ? 28 : size === "lg" ? 64 : 44;

  if (!url || errored) {
    return (
      <span className={`token-bubble ${sz} ${className}`} style={{ background: color }}>
        {symbol.slice(0, 3)}
      </span>
    );
  }

  return (
    <span
      className={`token-icon-wrap ${className}`}
      style={{
        width: dim, height: dim,
        background: "#0a0a0a",
        border: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <img
        src={url}
        alt={symbol}
        width={dim}
        height={dim}
        onError={() => setErrored(true)}
        loading="lazy"
        style={{ width: "100%", height: "100%", borderRadius: "999px", objectFit: "cover" }}
      />
    </span>
  );
}
